import React, { useState } from "react";
import { Table } from "antd";
import { useSelector } from "react-redux";
import { formatToCompanyTimezone, numberFormatTax } from "../../../../lib/functions";
import { selectAuthInfo } from "../../../Auth/authSelectors";

const SalesTaxLedgerTable = ({ printMode = false }) => {
  const { list, loading, opening_balance, closing_balance, totals } = useSelector(
    (state) => state.salesTaxLedger
  );
  const authInfo = useSelector(selectAuthInfo);
  const isIndia = authInfo?.country?.toLowerCase() === "india";
  const isGstEnabled = authInfo?.gst_enabled === "yes";
  const showGstColumns = isIndia && isGstEnabled;
  console.log(showGstColumns, totals, "totals");

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const columns = [
    {
      title: "No.",
      render: (_, __, index) => index + 1,
      width: 60
    },
    {
      title: "Date",
      dataIndex: "date", // ✅ matches thunk mapping
      render: (v) => v ? formatToCompanyTimezone(v).split(" ")[0] : "-",
    },
    {
      title: "Particular",
      dataIndex: "particular"
    },
    {
      title: "VCH No",
      dataIndex: "vch_no"
    },
    {
      title: "VCH Type",
      dataIndex: "vch_type"
    },
    {
      title: "Debit",
      dataIndex: "debit", // ✅ matches thunk mapping
      align: "right",
      render: val => Number(val || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    {
      title: "Credit",
      dataIndex: "credit", // ✅ matches thunk mapping
      align: "right",
      render: val => Number(val || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    showGstColumns && {
      title: "CGST",
      dataIndex: "cgst_amount",
      render: numberFormatTax,
      align: "right",
    },

    showGstColumns && {
      title: "SGST",
      dataIndex: "sgst_amount",
      render: numberFormatTax,
      align: "right",
    },

    showGstColumns && {
      title: "IGST",
      dataIndex: "igst_amount",
      render: numberFormatTax,
      align: "right",
    },
    {
      title: "Balance",
      dataIndex: "balance",
      align: "right",
      render: val => Number(val || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
  ].filter(Boolean);

  const grandTotals = list.reduce(
    (acc, row) => {
      acc.debit += Number(row.debit || 0);   // ✅ matches thunk mapping
      acc.credit += Number(row.credit || 0); // ✅ matches thunk mapping
      return acc;
    },
    { debit: 0, credit: 0 }
  );

if (printMode) {
  return (
    <table className="ledger-print-table">
      <colgroup>
        <col style={{ width: showGstColumns ? "3%" : "4%" }} />
        <col style={{ width: showGstColumns ? "8%" : "10%" }} />
        <col style={{ width: showGstColumns ? "18%" : "30%" }} />
        <col style={{ width: showGstColumns ? "13%" : "14%" }} />
        <col style={{ width: showGstColumns ? "8%" : "11%" }} />
        <col style={{ width: showGstColumns ? "9%" : "10%" }} />
        <col style={{ width: showGstColumns ? "9%" : "10%" }} />
        {showGstColumns && (
          <>
            <col style={{ width: "7%" }} />
            <col style={{ width: "7%" }} />
            <col style={{ width: "7%" }} />
          </>
        )}
        <col style={{ width: showGstColumns ? "11%" : "11%" }} />
      </colgroup>

      <tbody>
        <tr className="ledger-print-heading">
          <td>No.</td>
          <td>Date</td>
          <td>Particular</td>
          <td style={{ whiteSpace: "normal" }}>VCH No</td>
          <td>VCH Type</td>
          <td style={{ textAlign: "right" }}>Debit</td>
          <td style={{ textAlign: "right" }}>Credit</td>
          {showGstColumns && (
            <>
              <td style={{ textAlign: "right" }}>CGST</td>
              <td style={{ textAlign: "right" }}>SGST</td>
              <td style={{ textAlign: "right" }}>IGST</td>
            </>
          )}
          <td style={{ textAlign: "right" }}>Balance</td>
        </tr>

        <tr className="ledger-opening-row">
          <td colSpan={showGstColumns ? 10 : 7} style={{ textAlign: "right" }}>
            Opening Balance
          </td>
          <td style={{ textAlign: "right" }}>
            {Number(opening_balance || 0).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </td>
        </tr>

        {list.map((row, index) => (
          <tr key={index}>
            <td>{index + 1}</td>
            <td>
              {row.date ? formatToCompanyTimezone(row.date).split(" ")[0] : "-"}
            </td>
            <td>{row.particular}</td>
            <td style={{ whiteSpace: "normal", wordBreak: "break-all" }}>{row.vch_no}</td>
            <td>{row.vch_type}</td>
            <td style={{ textAlign: "right" }}>
              {Number(row.debit || 0).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </td>
            <td style={{ textAlign: "right" }}>
              {Number(row.credit || 0).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </td>
            {showGstColumns && (
              <>
                <td style={{ textAlign: "right" }}>
                  {numberFormatTax(row.cgst_amount)}
                </td>
                <td style={{ textAlign: "right" }}>
                  {numberFormatTax(row.sgst_amount)}
                </td>
                <td style={{ textAlign: "right" }}>
                  {numberFormatTax(row.igst_amount)}
                </td>
              </>
            )}
            <td style={{ textAlign: "right" }}>
              {Number(row.balance || 0).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </td>
          </tr>
        ))}

        <tr className="ledger-total-row">
          <td colSpan={5} style={{ textAlign: "right" }}>Grand Total</td>
          <td style={{ textAlign: "right" }}>
            {grandTotals.debit.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </td>
          <td style={{ textAlign: "right" }}>
            {grandTotals.credit.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </td>
          {showGstColumns && <td colSpan={3} />}
          <td />
        </tr>

        <tr className="ledger-closing-row">
          <td colSpan={showGstColumns ? 10 : 7} style={{ textAlign: "right" }}>
            Closing Balance
          </td>
          <td style={{ textAlign: "right" }}>
            {Number(closing_balance || 0).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </td>
        </tr>
      </tbody>
    </table>
  );
}

  return (
    <Table
      rowKey={(_, index) => index}
      columns={columns}
      dataSource={list}
      loading={loading}
      pagination={{
        ...pagination,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
      }}
      onChange={handleTableChange}
      bordered
      size={printMode ? "small" : "middle"}
      scroll={printMode ? undefined : { x: "max-content" }}
      summary={() => (
        <>
          <Table.Summary.Row>
            <Table.Summary.Cell index={0} colSpan={5} align="right">
              <strong>Opening Balance:</strong>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={5} colSpan={2} align="right">
              <strong>
                {Number(opening_balance || 0).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
              </strong>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={7} />
          </Table.Summary.Row>

          {showGstColumns && totals && (
            <>
              {/* GST Header */}
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={5} align="right">
                  <strong>GST Summary:</strong>
                </Table.Summary.Cell>
                <Table.Summary.Cell />
                <Table.Summary.Cell />
                <Table.Summary.Cell />
              </Table.Summary.Row>

              {/* CGST */}
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={5} align="right">
                  CGST
                </Table.Summary.Cell>
                <Table.Summary.Cell align="right">
                  {numberFormatTax(totals?.debit_cgst_total || 0)}
                </Table.Summary.Cell>
                <Table.Summary.Cell align="right">
                  {numberFormatTax(totals?.credit_cgst_total || 0)}
                </Table.Summary.Cell>
                <Table.Summary.Cell />
              </Table.Summary.Row>

              {/* SGST */}
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={5} align="right">
                  SGST
                </Table.Summary.Cell>
                <Table.Summary.Cell align="right">
                  {numberFormatTax(totals?.debit_sgst_total || 0)}
                </Table.Summary.Cell>
                <Table.Summary.Cell align="right">
                  {numberFormatTax(totals?.credit_sgst_total || 0)}
                </Table.Summary.Cell>
                <Table.Summary.Cell />
              </Table.Summary.Row>

              {/* IGST */}
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={5} align="right">
                  IGST
                </Table.Summary.Cell>
                <Table.Summary.Cell align="right">
                  {numberFormatTax(totals?.debit_igst_total || 0)}
                </Table.Summary.Cell>
                <Table.Summary.Cell align="right">
                  {numberFormatTax(totals?.credit_igst_total || 0)}
                </Table.Summary.Cell>
                <Table.Summary.Cell />
              </Table.Summary.Row>

              {/* TOTAL GST */}
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={5} align="right">
                  <strong>Total GST</strong>
                </Table.Summary.Cell>
                <Table.Summary.Cell align="right">
                  <strong>{numberFormatTax(totals?.debit_total || 0)}</strong>
                </Table.Summary.Cell>
                <Table.Summary.Cell align="right">
                  <strong>{numberFormatTax(totals?.credit_total || 0)}</strong>
                </Table.Summary.Cell>
                <Table.Summary.Cell />
              </Table.Summary.Row>
            </>
          )}
          <Table.Summary.Row>
            <Table.Summary.Cell index={0} colSpan={5} align="right">
              <strong>Grand Total:</strong>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={5} align="right">
              <strong>
                {grandTotals.debit.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
              </strong>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={6} align="right">
              <strong>
                {grandTotals.credit.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
              </strong>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={7} />
          </Table.Summary.Row>

          <Table.Summary.Row>
            <Table.Summary.Cell index={0} colSpan={5} align="right">
              <strong>Closing Balance:</strong>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={5} colSpan={2} align="right">
              <strong>
                {Number(closing_balance || 0).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
              </strong>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={7} />
          </Table.Summary.Row>
        </>
      )}
    />
  );
};

export default SalesTaxLedgerTable;